'use client';

import { cn } from '@/lib/utils';

interface RegisterStepperProps {
    currentStep: 1 | 2 | 3;
}

const steps = [
    { number: 1, label: 'Personal Info',  description: 'Owner details'   },
    { number: 2, label: 'Business Info',  description: 'Store profile'   },
    { number: 3, label: 'Complete',       description: 'Dashboard ready' },
];

export function RegisterStepper({ currentStep }: RegisterStepperProps) {
    return (
        <div className="flex items-center gap-0">
            {steps.map((step, idx) => {
                const done   = step.number < currentStep;
                const active = step.number === currentStep;

                return (
                    <div key={step.number} className="flex flex-1 items-center">
                        {/* Step item */}
                        <div className="flex flex-1 items-center gap-3 sm:gap-2.5">
                            {/* Circle */}
                            <div
                                className={cn(
                                    'flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-all duration-200',
                                    done   && 'bg-violet-600 text-white',
                                    active && 'bg-white text-violet-700 ring-2 ring-violet-600 ring-offset-2',
                                    !done && !active && 'bg-slate-100 text-slate-400',
                                )}
                            >
                                {done ? (
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                    </svg>
                                ) : (
                                    step.number
                                )}
                            </div>

                            {/* Labels — hidden on small screens except active */}
                            <div className={cn('hidden sm:block min-w-0')}>
                                <p className={cn(
                                    'truncate text-sm font-semibold leading-tight',
                                    active || done ? 'text-slate-900' : 'text-slate-400',
                                )}>
                                    {step.label}
                                </p>
                                <p className="mt-0.5 truncate text-xs text-slate-400">{step.description}</p>
                            </div>

                            {/* Active label visible on mobile */}
                            {active && (
                                <div className="sm:hidden min-w-0">
                                    <p className="truncate text-sm font-semibold text-slate-900">{step.label}</p>
                                    <p className="mt-0.5 truncate text-xs text-slate-400">{step.description}</p>
                                </div>
                            )}
                        </div>

                        {/* Connector */}
                        {idx < steps.length - 1 && (
                            <div className={cn(
                                'mx-3 h-px w-8 shrink-0 rounded-full transition-colors duration-300',
                                done ? 'bg-violet-400' : 'bg-slate-200',
                            )} />
                        )}
                    </div>
                );
            })}
        </div>
    );
}